import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ButtonHintComponent } from '@lx/shared/ui/button-hint';
import { tooltipAnimation } from '@lx/ui/animations';

type FieldType = 'text' | 'number' | 'checkbox';

@Component({
  standalone: true,
  selector: 'lx-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  animations: [tooltipAnimation],
  imports: [CommonModule, ButtonHintComponent],
})
export class FormFieldComponent {
  @ViewChild('tooltipElement') tooltipElement: ElementRef<HTMLDivElement> | undefined;
  @Input() label = '';
  @Input() small = false;
  @Input() tooltip = '';
  @Input() isValid = false;
  @Input() subLabel = '';
  @Input() disabled = false;
  @Input() withoutHelper = false;
  @Input() required = false;
  @Input() fieldType: FieldType | undefined;
  @Input() errorMessage = '';
  @Input() iconValidation = false;
}
